/**
 * SF-4770: Eva's words with their formatting (bold, lists, links, tables, code), like the web
 * app's Eva chat (react-markdown + remark-gfm). There is no rehype-raw on purpose: react-markdown
 * then shows raw HTML in a reply as text and never makes an element from it. Links open in a new
 * tab. EvaMarkdown.css only styles inside this component's class, so nothing global changes.
 */
import Markdown, { type Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './EvaMarkdown.css';

const components: Components = {
  a: ({ node: _node, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer" />,
  // Pictures are never loaded: Eva's text can quote a prospect's website, and loading a picture
  // from it would tell that site who is reading. Only the picture's description is shown.
  img: ({ alt }) => <span>{alt ? `[image: ${alt}]` : '[image]'}</span>,
  // A wide table scrolls inside the chat card instead of stretching it.
  table: ({ node: _node, ...props }) => (
    <div className="eva-markdown-table">
      <table {...props} />
    </div>
  ),
};

export const EvaMarkdown: React.FC<{ text: string }> = ({ text }) => (
  <div className="eva-markdown" data-testid="eva-markdown">
    <Markdown remarkPlugins={[remarkGfm]} components={components}>
      {text}
    </Markdown>
  </div>
);
